import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * @param {CustomPopup.propTypes} props
 * @return {JSX.Element}
 */
export default function CustomPopup(props) {
    const title = props.title ? props.title : 'Delete item?';
    const content = props.content ? props.content : 'Are you sure you want to delete this item?';

    return (<>
        <Dialog
            open={props.open}
            onClose={props.handleClose}
        >
            <div style={{display: 'flex'}}>
                {props.showErrorIcon &&
                    <div style={{backgroundColor: 'red', width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                        <i className="material-icons" style={{color: 'white'}}>{'error'}</i>
                    </div>
                }
                <div>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{content}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {props.buttons}
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    </>);
}

CustomPopup.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    buttons: PropTypes.array,
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    showErrorIcon: PropTypes.bool,
};
